var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloseCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M7.124 5.089L12.213 0l2.037 2.036-5.09 5.089 5.09 5.089-2.037 2.035L7.124 9.16l-5.089 5.089L0 12.214l5.088-5.089L0 2.036 2.035 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseCustom);
export default __webpack_public_path__ + "static/media/icon-close-custom.139035853d5686f4daf7d32217f38eb5.svg";
export { ForwardRef as ReactComponent };